import { render } from "./MachineDetailModal.vue?vue&type=template&id=713afe38"
import script from "./MachineDetailModal.vue?vue&type=script&lang=ts"
export * from "./MachineDetailModal.vue?vue&type=script&lang=ts"
script.render = render

export default script